/**
 * Hindi number words. 1 to 99 are irregular (उनतीस is 29, not "nine-twenty"), so every one is listed rather than
 * built by rule, with the spellings people and recognizers also use. Written as people write them; the parser
 * normalizes each entry (no nukta, anusvara for chandrabindu) when it loads.
 */
export const HI_NUMBERS = {
    values: {
        एक: 1,
        दो: 2,
        तीन: 3,
        चार: 4,
        पाँच: 5,
        छह: 6,
        छः: 6,
        छे: 6,
        छै: 6,
        सात: 7,
        आठ: 8,
        नौ: 9,
        दस: 10,
        ग्यारह: 11,
        बारह: 12,
        तेरह: 13,
        चौदह: 14,
        पंद्रह: 15,
        पन्द्रह: 15,
        सोलह: 16,
        सत्रह: 17,
        अठारह: 18,
        उन्नीस: 19,
        उनीस: 19,
        बीस: 20,
        इक्कीस: 21,
        बाईस: 22,
        तेईस: 23,
        तेइस: 23,
        चौबीस: 24,
        पच्चीस: 25,
        छब्बीस: 26,
        सत्ताईस: 27,
        अट्ठाईस: 28,
        अठाईस: 28,
        उनतीस: 29,
        उन्तीस: 29,
        तीस: 30,
        इकतीस: 31,
        इकत्तीस: 31,
        बत्तीस: 32,
        तैंतीस: 33,
        तेंतीस: 33,
        चौंतीस: 34,
        पैंतीस: 35,
        छत्तीस: 36,
        सैंतीस: 37,
        अड़तीस: 38,
        उनतालीस: 39,
        उन्तालीस: 39,
        चालीस: 40,
        इकतालीस: 41,
        बयालीस: 42,
        बियालीस: 42,
        तैंतालीस: 43,
        तेंतालीस: 43,
        चवालीस: 44,
        चौवालीस: 44,
        पैंतालीस: 45,
        छियालीस: 46,
        सैंतालीस: 47,
        अड़तालीस: 48,
        उनचास: 49,
        पचास: 50,
        इक्यावन: 51,
        इकावन: 51,
        बावन: 52,
        तिरपन: 53,
        तिरेपन: 53,
        चौवन: 54,
        चव्वन: 54,
        पचपन: 55,
        छप्पन: 56,
        सत्तावन: 57,
        अट्ठावन: 58,
        अठावन: 58,
        उनसठ: 59,
        साठ: 60,
        इकसठ: 61,
        बासठ: 62,
        तिरसठ: 63,
        तिरेसठ: 63,
        चौंसठ: 64,
        पैंसठ: 65,
        छियासठ: 66,
        सड़सठ: 67,
        सरसठ: 67,
        अड़सठ: 68,
        उनहत्तर: 69,
        सत्तर: 70,
        इकहत्तर: 71,
        बहत्तर: 72,
        तिहत्तर: 73,
        चौहत्तर: 74,
        पचहत्तर: 75,
        छिहत्तर: 76,
        सतहत्तर: 77,
        अठहत्तर: 78,
        अठत्तर: 78,
        उनासी: 79,
        उन्यासी: 79,
        अस्सी: 80,
        इक्यासी: 81,
        बयासी: 82,
        बियासी: 82,
        तिरासी: 83,
        चौरासी: 84,
        पचासी: 85,
        छियासी: 86,
        सत्तासी: 87,
        अट्ठासी: 88,
        नवासी: 89,
        नब्बे: 90,
        इक्यानवे: 91,
        बानवे: 92,
        बानबे: 92,
        तिरानवे: 93,
        चौरानवे: 94,
        पंचानवे: 95,
        पिचानवे: 95,
        छियानवे: 96,
        सत्तानवे: 97,
        अट्ठानवे: 98,
        निन्यानवे: 99,
        निन्यानबे: 99,
        // Fractions said as one word, before a multiplier: डेढ़ सौ 150, ढाई हज़ार 2,500.
        डेढ़: 1.5,
        ढाई: 2.5,
    },
    multipliers: { सौ: 100, हज़ार: 1000, लाख: 100_000, करोड़: 10_000_000 },
    // साढ़े आठ 8½, सवा सौ 125, पौने तीन 2¾.
    prefixes: { साढ़े: 0.5, सवा: 0.25, पौने: -0.25 },
};
//# sourceMappingURL=numbers-hi.js.map